import { Play } from 'lucide-react';
import { VORGANG_TYP_TRANSLATION_MAP } from './utils/common';
import { TimelineElement } from '../../components/ui/timeline/timeline-types';
import { VorgangDetail } from '../../types';

export const getTimelineItemForAbarbeitung = (
  vorgang: VorgangDetail,
  item: VorgangDetail['abarbeitungen'][number],
): Omit<TimelineElement, 'id'> => {
  return {
    date: new Date(item.gestartetAm),
    title: `Abarbeitung #${item.laufnummer} gestartet`,
    description: `Abarbeitung für einen ${VORGANG_TYP_TRANSLATION_MAP[vorgang.type]} Event gestartet`,
    initiator: item.initiator,
    status: 'completed',
    icon: <Play />,
    color: 'primary',
  };
};
